import { select, takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull } from 'lodash';
import {
  setLawyerAssignedClaims,
  setLegalProceedingsSteps,
} from 'containers/LawyerAssignmentsPage/actions';
import {
  REQUEST_LAWYER_ASSIGNED_CLAIMS,
  REQUEST_LEGAL_PROCEEDINGS_STEPS,
} from 'containers/LawyerAssignmentsPage/constants';
import { LawyerAssignmentSagaAction } from 'containers/LawyerAssignmentsPage/typings';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export function* fetchLawyerAssignedClaims(
  action: LawyerAssignmentSagaAction,
): Generator<unknown> {
  const {
    page,
    pageSize,
    assignedLawyer,
    step,
    procedureType,
    isDefaultAssignement,
  } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/assignment/lawyer-assigned-claims/v2`;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      assignedLawyer,
      page,
      pageSize,
      step,
      procedureType,
      isDefaultAssignement,
    }),
  };

  yield callApi(path, {}, options, [], setLawyerAssignedClaims);
}

export function* fetchProceedingsSteps(action: any): Generator<unknown> {
  const { claimId, judiciaryProcessId } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/judgement/claim-current-steps/${claimId}/${judiciaryProcessId}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setLegalProceedingsSteps);
}

export function* fetchLawyerAssignedClaimsSaga() {
  yield takeLeading(REQUEST_LAWYER_ASSIGNED_CLAIMS, fetchLawyerAssignedClaims);
}

export function* fetchProceedingsStepsSaga() {
  yield takeLeading(REQUEST_LEGAL_PROCEEDINGS_STEPS, fetchProceedingsSteps);
}

export default [fetchLawyerAssignedClaimsSaga, fetchProceedingsStepsSaga];
